"use client";

import React from "react";
import ModalTwoColumnInfoExample from "@/examples/modals/ModalTwoColumnInfoExample";

export default function ModalTwoColumnPage() {
  return (
    <div className="container mx-auto p-6">
      <ModalTwoColumnInfoExample />
    </div>
  );
}
